export const crmContent = {
  "create-crm": [
    {
      title: "How to create CRM in anydone?",
      link: "how-to-create-crm",
    },
    {
      title: "Managing Messages and Priorities in anydone CRM",
      link: "managing-messages",
    },
    {
      title: "How to Change Message Priority",
      link: "how-to-change-message",
    },
    {
      title: "Managing Spam Messages",
      link: "managing-spam-messages",
    },
    {
      title: "How to Mark a Message as Not Spam",
      link: "how-to-mark-message-as-not-spam",
    },
  ],
  "anydone-crm-ai-agent-platform": [
    {
      title: "Getting started with Anydone Automated CRM",
      link: "getting-started-with-crm",
    },
    {
      title: "Managing the CRM",
      link: "managing-crm",
    },
    {
      title: "Who is an Agent in anydone CRM? ",
      link:"who-is-an-agent"
    },
    {
      title: "How to Add a CRM Agent?",
      link:"how-to-add-crm"
    },
    {
        title: "What are CRM Roles ?",
        link:"crm-roles"
    },
    {
      title:"Creating a Custom Field in Anydone CRM",
      link:"creating-custom-field-in-crm"
    },
    {
        title: "What is a Source in anydone CRM?",
        link:"what-is-source-in-anydone"
    }
  ],
  "managing-crm":[
    {
      title: "How to link a folder in anydone CRM?",
      link: "how-to-link-folder-in-anydone",
    },
    {
      title: "Understanding anydone CRM Leads",
      link: "understanding-anydone-crm",
    },
    {
      title: "Managing CRM Contact List",
      link: "managing-crm-contact",
    },
    {
      title: "Managing Customer in CRM",
      link: "managing-customer",
    },
    {
      title: "How to Set and Manage Follow Up in CRM",
      link: "how-to-set-and-manage-crm",
    },
    {
      title: "Manage Label",
      link: "how-to-manage-label",
    },
    {
      title: "How to Create a Ticket in anydone CRM?  ",
      link: "how-to-create-ticket",
    },
    {
      title: "How to Open or Close a Conversation",
      link: "how-to-open-and-close-conversation",
    },
    {
      title: "How to add / remove Agents from CRM conversation?",
      link: "how-to-add-remove-agents-from-crm",
    },
    {
      title: "Understanding Information (i) Button of anydone CRM",
      link: "understanding-i-button-anydone",
    },
    {
      title: "What is Autopilot in anydone CRM?",
      link: "autopilot-crm",
    },
    {
      title: "How to Run a Email Campaign in anydone CRM",
      link: "how-to-run-email-campaign-in-crm",
    },
  ]
};
